var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "information-content" }, [
    _c("div", { staticClass: "mb-3" }, [
      _c("div", {
        staticClass: "registration-headline",
        class: _vm.inModalContext ? "h5" : "h4",
        domProps: {
          textContent: _vm._s(
            _vm.$t(
              "ui.components.users.onboarding.register.information.headline"
            )
          ),
        },
      }),
    ]),
    _c(
      "div",
      { staticClass: "text-center mb-4 d-none d-lg-block" },
      [_c("inline-svg", { attrs: { src: _vm.illustration } })],
      1
    ),
    _c(
      "ul",
      { staticClass: "list-unstyled registration-form__info-list w-100" },
      [
        _c("li", { staticClass: "d-flex align-items-start mb-1" }, [
          _c("div", { staticClass: "mdi mdi-check mr-2 text-xxl" }),
          _c("span", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t(
                  "ui.components.users.onboarding.register.information.bulletpoints.analysis_html"
                )
              ),
            },
          }),
        ]),
        _c("li", { staticClass: "d-flex align-items-start mb-1" }, [
          _c("div", { staticClass: "mdi mdi-check mr-2 text-xxl" }),
          _c("span", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t(
                  "ui.components.users.onboarding.register.information.bulletpoints.comparison_html"
                )
              ),
            },
          }),
        ]),
        _c("li", { staticClass: "d-flex align-items-start mb-1" }, [
          _c("div", { staticClass: "mdi mdi-check mr-2 text-xxl" }),
          _c("span", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t(
                  "ui.components.users.onboarding.register.information.bulletpoints.product_html"
                )
              ),
            },
          }),
        ]),
        _c("li", { staticClass: "d-flex align-items-start mb-1" }, [
          _c("div", { staticClass: "mdi mdi-check mr-2 text-xxl" }),
          _c("span", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t(
                  "ui.components.users.onboarding.register.information.bulletpoints.portfolios_html"
                )
              ),
            },
          }),
        ]),
        _c("li", { staticClass: "d-flex align-items-start" }, [
          _c("div", { staticClass: "mdi mdi-check mr-2 text-xxl" }),
          _c("span", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t(
                  "ui.components.users.onboarding.register.information.bulletpoints.advising_html"
                )
              ),
            },
          }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }